import React, { FC } from 'react'
import { Skeleton } from '@ui/skeleton/skeleton';

import { TogglePlaybackColumn } from '@app/web-player/tracks/track-table/toggle-playback-column';
import { AddToLibraryButton } from '@player/custom/AddToLibraryButton';

import { AddToQueueButton } from '@player/custom/AddToQueueButton'
import { Track } from '@player/types';

import { RowContext } from '@common/datatable/column-config';
import { useTrackTableMeta } from '@app/web-player/tracks/track-table/use-track-table-meta';

import { TrackTableMeta } from '@player/types';

export interface IndexTrackColumnProps {
    row: RowContext
    track: Track
}

export const IndexTrackColumn: FC<IndexTrackColumnProps> = ({ track, row }) => {
    const { hideQueueButton, hidePlaylistButton }: TrackTableMeta = useTrackTableMeta();

    if (row.isPlaceholder) {
        return (
            <div className="flex items-center gap-5">
                <Skeleton size="h-32 w-32" variant="rect" />
                {!hidePlaylistButton && <Skeleton size="h-32 w-32" variant="rect" />}
                {!hideQueueButton && <Skeleton size="h-32 w-32" variant="rect" />}
            </div>
        )
    }
    return (
        <div className="flex items-center gap-5">
            <TogglePlaybackColumn
                track={track}
                rowIndex={row.index}
                isHovered
            />

            {!hidePlaylistButton && (
                <AddToLibraryButton
                    track={track}
                />
            )}

            {!hideQueueButton && (
                <AddToQueueButton
                    track={track}
                />
            )}
        </div>
    );
}
